import type { Task } from '../../../lib/db/models'

type Update = (taskId: string, updates: Partial<Omit<Task, 'id'>>) => void | Promise<void>

/**
 * Für Seiten, deren Aufgaben-Details bewusst EINZELN schreiben (Demnächst): Der Stern (#210) gilt
 * trotzdem der ganzen Auswahl — wie der Stern selbst anzeigt, ob ALLE Favoriten sind.
 */
export function routeDetailsUpdate({ single, selection }: { single: Update; selection: Update }): Update {
  return (taskId, updates) => ('favoriteOrder' in updates ? selection(taskId, updates) : single(taskId, updates))
}
